import React, { PropsWithChildren, useCallback, useMemo } from 'react'
import FixedTooltip from '~/app/components/common/Tooltip/FixedTooltip'
import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'
import conf from '~/app/conf'

/**
 * CancelCommissionTooltip component
 * author: soojin.oh
 */

// CancelCommissionTooltip component
type Props = {
  arrowOffset?: number
  stickyTo?: 'left' | 'right'
} & Pick<React.HTMLProps<HTMLDivElement>, 'style'>

const CancelCommissionTooltip = function ({
  children,
  arrowOffset,
  stickyTo = 'left',
  style,
}: PropsWithChildren<Props>) {
  const onClick = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.wv({
        method: 'get',
        url: conf.customerCenter.url,
        layout: {
          title: '고객센터',
          modal: true,
        },
      })
    } else {
      window.open(conf.customerCenter.url, '_blank')
    }
  }, [])

  const content = useMemo(
    () => (
      <>
        <div className={'description'}>
          취소 수수료는 판매금액을 기준으로 계산됩니다. 자세한 사항은 취소 규정을 참고해주세요.{' '}
        </div>
        <a className={'link'} onClick={onClick}>
          {'카카오톡 1:1 문의 >'}
        </a>
      </>
    ),
    [onClick]
  )

  return (
    <FixedTooltip
      stickyTo={stickyTo}
      content={content}
      style={style}
      borderRadius={0.6}
      pointHorizontalOffset={arrowOffset}
    >
      {children}
    </FixedTooltip>
  )
}

export default CancelCommissionTooltip
